import { List, Record } from "immutable";

import compactDisplays from "../../../../constants/compactDisplay";
import itemTypeCategories from "../../../../constants/itemTypeCategories";
import { DEFAULT_DISPLAY_LABELS } from "../../../../constants/styles/typeLabels";
import createFromJS from "../../../createFromJS";

export const TypeRecord = Record({
  // Is this type enabled or disabled within the interface?
  enabled: true,
  canDelete: true,
  // the other properties
  id: null,
  label: null,
  pluralLabel: null,
  labelDisplayLabel: DEFAULT_DISPLAY_LABELS.LABEL,
  startDisplayLabel: DEFAULT_DISPLAY_LABELS.START_DATE,
  endDisplayLabel: DEFAULT_DISPLAY_LABELS.END_DATE,
  anniversaryDisplayLabel: DEFAULT_DISPLAY_LABELS.ANNIVERSARY,
  extendAnniversaryBeyondEnd: true,
  references: List(),
  properties: List(),
  superTypes: List(),
  icon: null,
  color: null, // This color is the icon color
  defaultItemColor: null, // The default color when creating new item
  canHaveDate: false,
  canIncludeInNarrative: false,
  showInSequence: false,
  showOnSidebar: false,
  showAsColumn: false,
  columnIsVisible: false,
  identifierPrefix: null,
  compactDisplay: compactDisplays.IDENTIFIER,
  category: itemTypeCategories.OTHER,
  isNarrativeFolder: false,
  defaultSequenceType: false,
  defaultNarrativeType: false,
  canHaveLocationUri: false
});

const data = {
  objects: {
    properties: "List",
    references: "List",
    superTypes: "List"
  }
};
createFromJS.registerCallback("TypeRecord", createFromJS.createNestedCallback(TypeRecord, data));
